import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OeContainerListItem extends SearchModelBase {
    containerId: number = 0;
    id: string = '';
    containerNo: string = '';
    conType: string = '';
    refNo: string = '';
    pickupNo: string = '';
    sealNo: string = '';
    inDate: string | null = null;
    fromInDate: string | null = null;
    toInDate: string | null = null;
    outDate: string | null = null;
    fromOutDate: string | null = null;
    toOutDate: string | null = null;
    emptryReturn: string | null = null;
    fromEmptryReturn: string | null = null;
    toEmptryReturn: string | null = null;
    ord: string | null = null;
    fromOrd: string | null = null;
    toOrd: string | null = null;
    atd: string | null = null;
    fromAtd: string | null = null;
    toAtd: string | null = null;
    rAtd: string | null = null;
    fromRAtd: string | null = null;
    toRAtd: string | null = null;
    rAta: string | null = null;
    fromRAta: string | null = null;
    toRAta: string | null = null;
    puDate: string | null = null;
    fromPuDate: string | null = null;
    toPuDate: string | null = null;
    dcDate: string | null = null;
    fromDcDate: string | null = null;
    toDcDate: string | null = null;
    kgs: number|null = null;
    fromKgs: number|null = null;
    toKgs: number|null = null;
    lbs: number|null = null;
    fromLbs: number|null = null;
    pkgs: number|null = null;
    toPkgs: number|null = null;
    fromPkgs: number|null = null;
    toLbs: number|null = null;
    mblNo: string = '';
    vessel: string = '';
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    //id: number = 0;
    oeMblId: number = 0;
    commodity: string = '';

    // Mbl
    status: string = '';
    recognized: string = '';
    prepBy: string = '';
    mblCreatedDate: string | null = null;
    frommblCreatedDate: string | null = null;
    tomblCreatedDate: string | null = null;
    mblCreateBy: string = '';

    loadingPort: string = '';
    dischargePort: string = '';
    voyage: string = '';
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    placeOfDelivery: string = '';
    
    trType: string = ''
    trStatus: string = ''
    trStatusDesc: string = ''
    trDate: string | null = null;
    fromTrDate: string | null = null;
    toTrDate: string | null = null;

    //Track Event
    lastEvent: string = '';
    lastEventDate: string | null = null;

    hblNo: string = '';
    customerName: string = '';
    steamShipName: string = '';
    hblId: number = 0;

    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;


    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status' }),
        XCol.Create({ col: 1, text: 'R.Date', width: 80, dataIndex: 'confirmDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 2, text: 'Prep. By', width: 60, dataIndex: 'prepBy', defaultColumnFocus: true }),
        XCol.Create({ col: 3, text: 'Container #', width: 100, dataIndex: 'containerNo', defaultColumnFocus : true}),
        // XCol.Create({ col: 2, text: 'FT', width: 40, dataIndex: 'ft', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, visible: false, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'Type', width: 60, dataIndex: 'conType'}),
        XCol.Create({ col: 5, text: 'Ref. #', width: 100, dataIndex: 'refNo'}),
        XCol.Create({ col: 7, text: 'MBL #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 8, text: 'HBL #', width: 100, dataIndex: 'hblNo'}),
        XCol.Create({ col: 9,  text: 'Customer', width: 150, dataIndex: 'customerName' }),
        XCol.Create({ col: 10, text: 'RQ Date', width: 100, dataIndex: 'trDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 11, text: 'Container Tracking', width: 210, dataIndex: 'trStatus' }),
        XCol.Create({ col: 12, text: 'Container Dispatched', width: 115, dataIndex: 'ord', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 13, text: 'Gate In', width: 100, dataIndex: 'inDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 14, text: 'Load on Vessel', width: 100, dataIndex: 'loadDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 15, text: 'Vessel Departure', width: 100, dataIndex: 'atd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 16, text: 'Vessel Arrival', width: 100, dataIndex: 'ata', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 17, text: 'Unloaded Vessel', width: 100, dataIndex: 'unloadDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 18, text: 'ETD', width: 100, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 19, text: 'ETA', width: 100, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
       
        XCol.Create({ col: 20, text: 'Loading Port', width: 100, dataIndex: 'loadingPort' }),
        XCol.Create({ col: 21, text: 'Discharge Port', width: 100, dataIndex: 'dischargePort' }),
        XCol.Create({ col: 22, text: 'Place of Delivery', width: 100, dataIndex: 'placeOfDelivery' }),
        XCol.Create({ col: 23, text: 'Vessel', width: 120, dataIndex: 'vessel'}),
        XCol.Create({ col: 24, text: 'Carrier', width: 120,  dataIndex: 'steamShipName' }),
        XCol.Create({ col: 25, text: 'Voyage', width: 120, dataIndex: 'voyage' }),
        // XCol.Create({ col: 22, text: 'Carrier Release', width: 75, dataIndex: 'carrierRls', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        // XCol.Create({ col: 23, text: 'Customs Release', width: 75, dataIndex: 'customRls', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        // XCol.Create({ col: 4, text: 'Seal #', width: 100, dataIndex: 'sealNo'}),
        // XCol.Create({ col: 7, text: 'Pickup #', width: 120, dataIndex: 'pickupNo'}),
        // XCol.Create({ col: 11, text: 'Gate Out', width: 75, dataIndex: 'outDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 12, text: 'Empty Return', width: 100, dataIndex: 'emptryReturn', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 13, text: 'Origin Receipt', width: 75, dataIndex: 'ord', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 14, text: 'ATD', width: 75, dataIndex: 'atd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 15, text: 'Rail ATD', width: 75, dataIndex: 'rAtd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 16, text: 'Rail RTA', width: 75, dataIndex: 'rAta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        // XCol.Create({ col: 17, text: 'Pickup Date', width: 75, dataIndex: 'puDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false,}),
        // XCol.Create({ col: 18, text: 'Deliver Date', width: 75, dataIndex: 'dcDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false, }),
        // XCol.Create({ col: 19, text: 'Commodity', width: 80, dataIndex: 'commodity'}),
        // XCol.Create({ col: 20, text: 'PKGS', width: 60, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        // XCol.Create({ col: 21, text: 'KGS', width: 60, dataIndex: 'kgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        // XCol.Create({ col: 22, text: 'LBS', width: 60, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 26, text: 'Create', width: 75, dataIndex: 'mblCreatedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 27, text: 'Create By', width: 75, dataIndex: 'mblCreateBy' }),
        XCol.Create({ col: 28, text: 'RQ By', width: 75, dataIndex: 'trBy' }),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: OeContainerListItem.prototype.containerId, orderByAscending: false };

    public static formatData(data: OeContainerListItem[]) {
        return data.map((d: OeContainerListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        inDate: {from: 'fromInDate', to: 'toInDate'},
        outDate: {from: 'fromOutDate', to: 'toOutDate'},
        emptryReturn: {from: 'fromEmptryReturn', to: 'toEmptryReturn'},
        ord: {from: 'fromOrd', to: 'toOrd'},
        atd: {from: 'fromAtd', to: 'toAtd'},
        rAtd: {from: 'fromRAtd', to: 'toRAtd'},
        rAta: {from: 'fromRAta', to: 'toRAta'},
        fromRAta: {from: 'fromRAta', to: 'toRAta'},
        puDate: {from: 'fromPuDate', to: 'toPuDate'},
        ccDate: {from: 'fromDcDate', to: 'toDcDate'},
        pkgs: {from: 'fromPkgs', to: 'toPkgs'},
        kgs: {from: 'fromKgs', to: 'toKgs'},
        lbs: {from: 'fromLbs', to: 'toLbs'},
        eta: {from: 'fromEta', to: 'toEta'},
        mblCreatedDate: { from: 'frommblCreatedDate', to: 'tomblCreatedDate' },
        confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'},
        etd: { from: 'fromEtd', to: 'toEtd' },
        trDate: {from: 'fromTrDate', to: 'toTrDate' },
    }
}
